// extracted by mini-css-extract-plugin
module.exports = {"heroImage":"Styles_heroImage__has2P"};